common.View.create('canvas.blocks.sky.sliderAlfa.Block', {

    onDOMLoad() {

        this.initSlider();
    },

    initSlider() {

        var logoOwl = this.element.find('.owl-carousel').owlCarousel({
            loop: false,
            margin: 0,
            nav: this.element.find('.owl-carousel').data('show-navigation'),
            dots: false,
            autoplay:true,
            autoplayTimeout:2500,
            autoplayHoverPause:true,
            responsive: {
                0: {
                    items: 1
                },
                200: {
                    items: 2
                },
                640: {
                    items: 3
                },
                1000: {
                    items: 5
                }
            }
        });

    }
});
